"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.setInactiveStaff = exports.setIsolatedStaff = exports.setQuarantinedStaff = exports.setUnknownStaff = exports.setHealthyStaff = exports.setPendingStaff = exports.setAllStaff = exports.setInactiveStudents = exports.setIsolatedStudents = exports.setQuarantinedStudents = exports.setUnknownStudents = exports.setHealthyStudents = exports.setPendingStudents = exports.setAllStudents = exports.resetRosters = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var rostersSlice = toolkit_1.createSlice({
    name: 'dashboard',
    initialState: {
        students: { all: [], pending: [], healthy: [], unknown: [], quarantined: [], isolated: [], inactive: [] },
        staff: { all: [], pending: [], healthy: [], unknown: [], quarantined: [], isolated: [], inactive: [] },
    },
    reducers: {
        resetRosters: function (state, action) {
            return {
                students: {
                    all: [],
                    pending: [],
                    healthy: [],
                    unknown: [],
                    quarantined: [],
                    isolated: [],
                    inactive: [],
                },
                staff: {
                    all: [],
                    pending: [],
                    healthy: [],
                    unknown: [],
                    quarantined: [],
                    isolated: [],
                    inactive: [],
                },
            };
        },
        setAllStudents: function (state, action) {
            return __assign(__assign({}, state), { students: __assign(__assign({}, state.students), { all: action.payload }) });
        },
        setPendingStudents: function (state, action) {
            return __assign(__assign({}, state), { students: __assign(__assign({}, state.students), { pending: action.payload }) });
        },
        setHealthyStudents: function (state, action) {
            return __assign(__assign({}, state), { students: __assign(__assign({}, state.students), { healthy: action.payload }) });
        },
        setUnknownStudents: function (state, action) {
            return __assign(__assign({}, state), { students: __assign(__assign({}, state.students), { unknown: action.payload }) });
        },
        setQuarantinedStudents: function (state, action) {
            return __assign(__assign({}, state), { students: __assign(__assign({}, state.students), { quarantined: action.payload }) });
        },
        setIsolatedStudents: function (state, action) {
            return __assign(__assign({}, state), { students: __assign(__assign({}, state.students), { isolated: action.payload }) });
        },
        setInactiveStudents: function (state, action) {
            return __assign(__assign({}, state), { students: __assign(__assign({}, state.students), { inactive: action.payload }) });
        },
        setAllStaff: function (state, action) {
            return __assign(__assign({}, state), { staff: __assign(__assign({}, state.staff), { all: action.payload }) });
        },
        setPendingStaff: function (state, action) {
            return __assign(__assign({}, state), { staff: __assign(__assign({}, state.staff), { pending: action.payload }) });
        },
        setHealthyStaff: function (state, action) {
            return __assign(__assign({}, state), { staff: __assign(__assign({}, state.staff), { healthy: action.payload }) });
        },
        setUnknownStaff: function (state, action) {
            return __assign(__assign({}, state), { staff: __assign(__assign({}, state.staff), { unknown: action.payload }) });
        },
        setQuarantinedStaff: function (state, action) {
            return __assign(__assign({}, state), { staff: __assign(__assign({}, state.staff), { quarantined: action.payload }) });
        },
        setIsolatedStaff: function (state, action) {
            return __assign(__assign({}, state), { staff: __assign(__assign({}, state.staff), { isolated: action.payload }) });
        },
        setInactiveStaff: function (state, action) {
            return __assign(__assign({}, state), { staff: __assign(__assign({}, state.staff), { inactive: action.payload }) });
        },
    },
});
exports.resetRosters = (_a = rostersSlice.actions, _a.resetRosters), exports.setAllStudents = _a.setAllStudents, exports.setPendingStudents = _a.setPendingStudents, exports.setHealthyStudents = _a.setHealthyStudents, exports.setUnknownStudents = _a.setUnknownStudents, exports.setQuarantinedStudents = _a.setQuarantinedStudents, exports.setIsolatedStudents = _a.setIsolatedStudents, exports.setInactiveStudents = _a.setInactiveStudents, exports.setAllStaff = _a.setAllStaff, exports.setPendingStaff = _a.setPendingStaff, exports.setHealthyStaff = _a.setHealthyStaff, exports.setUnknownStaff = _a.setUnknownStaff, exports.setQuarantinedStaff = _a.setQuarantinedStaff, exports.setIsolatedStaff = _a.setIsolatedStaff, exports.setInactiveStaff = _a.setInactiveStaff;
exports.default = rostersSlice.reducer;
